/**
 * @description  Utils constants like time definition
 */
export default Object.freeze({
  ONE_SECOND: 1000,
})
